// useCapabilities — preferred entry point for capability gating.
//
// Reads the live session + active role from React context and recomputes
// the capability bag whenever either changes. Existing callers that use
// the legacy `capabilitiesFor(role)` helper continue to work via the
// `_setLatchedSession` shim; new code should prefer this hook.

import { useMemo } from "react";
import { useSession } from "@/session";
import { useRole } from "./context";
import { computeCapabilities, type RoleCapabilities } from "./capabilities";

export function useCapabilities(): RoleCapabilities {
  const { session } = useSession();
  const { currentRole } = useRole();
  return useMemo(
    () => computeCapabilities(session, currentRole),
    [session, currentRole],
  );
}
